import { useState, useEffect } from 'react';

export default (timeout, delay) => {
  const [slideClass, setSliderClass] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setSliderClass('pageViewSlideIn');
      setTimeout(() => {
        setSliderClass('');
      }, timeout);
    }, delay);
  }, []);

  return {
    slideClass, setSliderClass
  };
};
